import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './ImageTextPaginated.css';

type slideTuple = {
    imageUrl?: string;
    videoUrl?: string;
    heading: string;
    description: string;
    linkUrl?: string;
    linkLabel?: string;
};

interface ImageTextPaginatedProps {
    foregroundColor: string;
    backgroundColor: string;
    heading: string,
    slides: slideTuple[];
}

function ImageTextPaginated({ foregroundColor, backgroundColor, heading, slides }: ImageTextPaginatedProps) {
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState(0);
    const currentContent = slides[activePage];

    const handlePageToggle = (pageIndex: number) => {
        setActivePage(pageIndex);
    };

    const handleNavigation = (url: string) => {
        navigate(url);
    };

    const componentStyle = {
        '--_color': foregroundColor,
        '--_background-color': backgroundColor,
    } as React.CSSProperties;

    const showLinks = false;

    return (
        <section className="image-text-paginated" style={componentStyle}>
            <div className="image-text-paginated__heading-wrapper">
                <h2 className="image-text-paginated__heading">{heading}</h2>
            </div>
            <div className="image-text-paginated__inner">
                <div className="image-text-paginated__media">
                    {currentContent.imageUrl && (
                        <img src={currentContent.imageUrl} alt={currentContent.heading} className="image-text-paginated__image" />
                    )}
                    {currentContent.videoUrl && (
                        <video className="image-text-paginated__video" controls autoPlay loop muted playsInline>
                            <source src={currentContent.videoUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    )}
                </div>
                <div className="image-text-paginated__content-wrapper">
                    <div className="image-text-paginated__content">
                        <div className="image-text-paginated__content-text">
                            <h2 className="image-text-paginated__content-heading">{currentContent.heading}</h2>
                            <div className="image-text-paginated__description">
                                {currentContent.description}
                            </div>
                            {
                                (currentContent.linkUrl && currentContent.linkLabel && showLinks) && (
                                    <a href={currentContent.linkUrl} className="image-text-paginated__link">{currentContent.linkLabel}</a>
                                )
                            }
                        </div>
                        {
                            slides.length > 1 && (
                                <div className="image-text-paginated__page-list">
                                    {slides.map((_, index) => (
                                        <div className={`image-text-paginated__page-item ${activePage === index ? 'is-active' : ''}`} key={index} onClick={() => handlePageToggle(index)}>
                                            {index + 1}
                                        </div>
                                    ))}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageTextPaginated;